export const JOURNAL_ENTRY_SOURCE = {
  MANUAL: "MANUAL",
  SYSTEM: "SYSTEM",
};

export type JOURNAL_ENTRY_SOURCES_TYPE = keyof typeof JOURNAL_ENTRY_SOURCE;

export const JOURNAL_ENTRY_STATUS = {
  ARCHIVED: "ARCHIVED",
  ACTIVE: "ACTIVE",
};

export type JOURNAL_ENTRY_STATUS_TYPE =
  (typeof JOURNAL_ENTRY_STATUS)[keyof typeof JOURNAL_ENTRY_STATUS];

export const JOURNAL_ENTRY_SOURCES_DISPLAY = {
  [JOURNAL_ENTRY_SOURCE.MANUAL]: "Manually added",
  [JOURNAL_ENTRY_SOURCE.SYSTEM]: "System generated",
};

export const JOURNAL_ENTRY_STATUS_DISPLAY = {
  [JOURNAL_ENTRY_STATUS.ARCHIVED]: "archived",
  [JOURNAL_ENTRY_STATUS.ACTIVE]: "marked as active",
};

export const LT_SERIAL_NUMBER_PREFIX = "LT";

export const SORT_COLUMNS = {
  CREATED_AT: { label: "Creation date", value: "CREATED_AT" },
  DATE: { label: "Entry date", value: "DATE" },
} as const;

export const SORT_ORDERS = {
  NEWEST: { label: "Newest to oldest", value: true },
  OLDEST: { label: "Oldest to newest", value: false },
} as const;

export type JESortColumnType = "DATE" | "CREATED_AT";
